import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";
import Tooltipable from "~/components/effects/tooltipable";
import GlobalContainer from "~/components/global_container";
import { apiFetch } from "~/lib/fetchClient";
import { FeedbackStates } from "../../states/FeedbackStates";

const Feedback = ({ state, dispatch }) => {
  const feedbackHandler = (feedback) => async () => {
    if (state.feedbackState === feedback) {
      dispatch({ type: "SET_FEEDBACK_STATE", payload: null });
    } else {
      dispatch({ type: "SET_FEEDBACK_STATE", payload: feedback });
    }
  };

  const handleThumbsUp = feedbackHandler(FeedbackStates.UP);
  const handleThumbsDown = feedbackHandler(FeedbackStates.DOWN);

  const handleSendFeedback = async () => {
    const { conversationId, feedbackSending, feedbackState, feedbackText } =
      state;

    if (feedbackSending) {
      return null;
    }

    dispatch({ type: "SET_FEEDBACK_SENDING", payload: true });

    try {
      await apiFetch.post("/ai_ratings", {
        json: {
          rating: {
            ai_conversation_id: conversationId,
            rating: feedbackState,
            feedback: feedbackText,
          },
        },
      });

      dispatch({ type: "SET_FEEDBACK_TEXT", payload: "" });
      dispatch({ type: "SET_FEEDBACK_STATE", payload: null });

      GlobalContainer.notify(
        "Thank you for your feedback. It's been sent successfully.",
        "success",
      );

      return null;
    } catch (error) {
      GlobalContainer.notify(
        "Oops! There was an issue sending your feedback. Please try again.",
        "error",
      );

      return null;
    } finally {
      dispatch({ type: "SET_FEEDBACK_SENDING", payload: false });
    }
  };

  return (
    <>
      <div className="d-flex align-items-center flex-shrink-0">
        <Tooltipable text="Good response" placement="bottom">
          <button
            type="button"
            className={`btn btn-sm rounded-circle p-0 d-flex align-items-center justify-content-center wpx24 hpx24 ${
              state.feedbackState === FeedbackStates.UP
                ? "btn-success"
                : "btn-outline-success"
            }`}
            onClick={handleThumbsUp}
            disabled={state.feedbackSending}
          >
            <FontAwesomeIcon icon="far fa-thumbs-up" className="text-xs" />
          </button>
        </Tooltipable>

        <Tooltipable text="Bad response" placement="bottom">
          <button
            type="button"
            className={`btn btn-sm rounded-circle p-0 d-flex align-items-center justify-content-center wpx24 hpx24 ml-1 ${
              state.feedbackState === FeedbackStates.DOWN
                ? "btn-danger"
                : "btn-outline-danger"
            }`}
            onClick={handleThumbsDown}
            disabled={state.feedbackSending}
          >
            <FontAwesomeIcon icon="far fa-thumbs-down" className="text-xs" />
          </button>
        </Tooltipable>
      </div>

      {state.feedbackState && (
        <div className="w-100 mt-2">
          <div className="d-flex">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Optional feedback..."
              value={state.feedbackText}
              onChange={(e) =>
                dispatch({
                  type: "SET_FEEDBACK_TEXT",
                  payload: e.target.value,
                })
              }
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSendFeedback();
                }
              }}
            />
            <button
              type="button"
              className="btn btn-sm btn-success ml-1 flex-shrink-0"
              onClick={handleSendFeedback}
              disabled={state.feedbackSending}
            >
              Send
            </button>
          </div>
        </div>
      )}
    </>
  );
};

Feedback.propTypes = {
  state: PropTypes.shape({}).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default Feedback;
